import * as tslib_1 from "tslib";
import { put, call, select, all, fork, cancelled, delay, } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import ddt from '@wix/da-ddt';
import { initDeviationPage } from '../../DeviationPage/redux/actions';
import { DeviationResourceType } from '../../types/deviation';
import { request } from '../../xhr/request';
import { getItemIdsForPreload } from './selectors';
import { getExtendedDeviationById, getDeviationIdFromNormalizedId, } from '../../redux/deviations/selectors';
import { getCommentCursorFromQuery } from '../../CommentThread/helpers';
import queryString from 'query-string';
import history from '../../redux/routing/history';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { putEntities } from '../../redux/entities/actions';
import { getAboveFoldSections } from '../../Sidebar/helpers';
import { isExtendedDeviationFullyLoaded } from '../../DeviationPage/redux/helpers';
var logger = ddt.createLogger('duperbrowse');
function getDeviationPageTypeFromTypeId(typeId) {
    switch (typeId) {
        case DeviationResourceType.JOURNAL:
            return 'journal';
        case DeviationResourceType.COMMISSION:
            return 'commission';
        case DeviationResourceType.POLL:
            return 'poll';
        case DeviationResourceType.STATUS:
            return 'status-update';
        default:
            return 'art';
    }
}
function preloadAboveFoldSidebar(deviation) {
    var params, result, partiallyLoadedDeviation, entities;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {
                    deviationid: deviation.deviationId,
                    username: deviation.author && deviation.author.username,
                    type: getDeviationPageTypeFromTypeId(deviation.typeId),
                    blocks: getAboveFoldSections(deviation),
                };
                logger.log('Preloading above fold', deviation.deviationId, params.blocks);
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'deviation/related',
                        params: params,
                    }, function () {
                        if (process.env.NODE_ENV !== 'production') {
                            // eslint-disable-next-line
                            var Fake = require('@wix/da-sample-data').Fake;
                            return Fake.extendDeviation(deviation, {}).extended
                                .relatedStreams;
                        }
                        return false;
                    })];
            case 1:
                result = _a.sent();
                if (!result) {
                    return [2 /*return*/];
                }
                partiallyLoadedDeviation = tslib_1.__assign({}, deviation, { extended: { isComplete: false, relatedStreams: result } });
                entities = normalize(partiallyLoadedDeviation, deviationSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 2:
                _a.sent();
                return [2 /*return*/, result];
        }
    });
}
function loadDeviation(itemId, preload, currentDeviationId) {
    var deviation, preloadedRelated, params, _a, result, mergedDeviation;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getExtendedDeviationById, itemId)];
            case 1:
                deviation = _b.sent();
                if (isExtendedDeviationFullyLoaded(deviation)) {
                    // already loaded, we good
                    logger.log('Deviation already loaded, bailing', itemId);
                    return [2 /*return*/, false];
                }
                if (!!preload) return [3 /*break*/, 3];
                return [4 /*yield*/, call(preloadAboveFoldSidebar, deviation)];
            case 2:
                preloadedRelated = _b.sent();
                _b.label = 3;
            case 3:
                logger.log('Loading deviation', itemId, { preload: preload, currentDeviationId: currentDeviationId });
                _b.label = 4;
            case 4:
                _b.trys.push([4, , 9, 11]);
                params = {
                    deviationid: deviation.deviationId,
                    username: deviation.author && deviation.author.username,
                    type: getDeviationPageTypeFromTypeId(deviation.typeId),
                    include_session: false,
                    comments_cursor: getCommentCursorFromQuery(queryString.parse(history.location.search), { itemId: deviation.deviationId }),
                };
                if (!preload) return [3 /*break*/, 6];
                params.preload = true;
                if (!currentDeviationId) return [3 /*break*/, 6];
                _a = params;
                return [4 /*yield*/, select(getDeviationIdFromNormalizedId, currentDeviationId)];
            case 5:
                _a.current_id = _b.sent();
                _b.label = 6;
            case 6: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: 'deviation/extended_fetch',
                    params: params,
                }, function () {
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line
                        var chance = require('chance').Chance();
                        // eslint-disable-next-line
                        var _a = require('@wix/da-sample-data'), Fake = _a.Fake, commentThreads = _a.commentThreads;
                        return {
                            deviation: Fake.extendDeviation(deviation, {}),
                            comments: tslib_1.__assign({}, chance.pickone(commentThreads), { commentableItemid: deviation.deviationId, commentableTypeid: deviation.typeId }),
                        };
                    }
                    return false;
                })];
            case 7:
                result = _b.sent();
                if (!result) {
                    return [2 /*return*/, false];
                }
                mergedDeviation = tslib_1.__assign({}, result.deviation);
                if (preloadedRelated && mergedDeviation.extended) {
                    mergedDeviation.extended.relatedStreams = tslib_1.__assign({}, mergedDeviation.extended.relatedStreams, preloadedRelated);
                }
                return [4 /*yield*/, put(initDeviationPage(mergedDeviation, result.comments))];
            case 8:
                _b.sent();
                return [2 /*return*/, true];
            case 9: return [4 /*yield*/, cancelled()];
            case 10:
                if (_b.sent()) {
                    logger.log('Loading canceled', deviation, { preload: preload });
                }
                return [7 /*endfinally*/];
            case 11: return [2 /*return*/];
        }
    });
}
function getLoader(itemSchema) {
    switch (itemSchema) {
        case 'deviation':
            return loadDeviation;
        default:
    }
}
export function handleLoading(_a) {
    var loader, wasRealLoad, currentItem, navigation, preloadEffects;
    var _b = _a.payload, itemId = _b.itemId, itemSchema = _b.itemSchema, preloadDirection = _b.preloadDirection;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, delay(200)];
            case 1:
                _c.sent(); // debounce
                loader = getLoader(itemSchema);
                if (!loader) {
                    logger.log('No loader found', itemSchema);
                    return [2 /*return*/];
                }
                logger.log('Starting main load', itemId);
                return [4 /*yield*/, call(loader, itemId, false)];
            case 2:
                wasRealLoad = _c.sent();
                currentItem = wasRealLoad ? undefined : itemId;
                return [4 /*yield*/, select(getItemIdsForPreload, preloadDirection)];
            case 3:
                navigation = _c.sent();
                preloadEffects = navigation.map(function (item) {
                    return fork(loader, item, true, currentItem);
                });
                logger.log('Forking preloads', navigation);
                // here we fork out the preloaders to do their thing async
                return [4 /*yield*/, all(preloadEffects)];
            case 4:
                // here we fork out the preloaders to do their thing async
                _c.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=loader.js.map